module.exports = __webpack_public_path__ + "static/vortune_main_3-862b3d6b8cfeeedc607615b0781200a2.png";